<template>
    <div class="section grey-card">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="7" class="px-10 text-center">
                    <h1>Turn Broadcasts into Conversations</h1>
                    <h2 class="text-h5 font-italic mb-5">A campaign isn’t just an announcement — it’s a conversation starter.</h2>
                    <p> 
                        When a recipient responds, Yabbr automatically routes their message into your Live Chat, where your team can reply instantly by SMS, MMS, email, or even connect them to a voice call. Keyword triggers can be set to instantly connect high-value leads or urgent cases to the right team.
                    </p>
                    <div class="d-flex justify-center"><hr/></div>
                    
                    <h2 class="text-h6 font-weight-bold mb-5">Contact Import</h2>
                        Once a conversation begins, Yabbr automatically imports the contact and their message history into your custom Web Chat, creating a complete profile with all future interactions stored for easy reference.
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'CampaignsTwoWay',
}
</script>

<style lang="scss">


hr {
    margin: 1em 0;
    width: 50%;
}
</style>